/**
 * Created by aaikepae on 11/3/16.
 */
import initialState from '../store/initialState';

export default function reducer(state = initialState.config, action) {
  if (action.type == "FETCH_CONFIG") {
    return Object.assign({}, state, action.payload);
  } else if (action.type == "UPDATE_CONFIG_LOCATION") {
    return {...state, location: action.payload}
  } else if (action.type == "UPDATE_CONFIG_CODE_LANGUAGE") {
    return {...state, defaultCodeLanguage: action.payload}
  } else if (action.type == "UPDATE_CONFIG") {
    return {...state, [action.payload.key]: action.payload.value}
  }else if (action.type == "CLEAR") {
    return {...initialState.config}
  }

  return state
}
